import { type SegmentsClientInterface } from './segmentsClient.types';
import CorporateSegmentsClient from './corporateSegmentsClient';
import GroupSegmentsClient from './groupSegmentsClient';
import OrgUnitSegmentsClient from './orgUnitSegmentsClient';
import type { ClientContext } from '~/services/contextClient';

export default class SegmentsClientFactory {
    static createClient(context: ClientContext): SegmentsClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateSegmentsClient(context.teamId);
        } else if (context.orgUnitId) {
            return new OrgUnitSegmentsClient(context.teamId, context.orgUnitId);
        } else if (context.groupId) {
            return new GroupSegmentsClient(context.teamId, context.groupId);
        }

        throw new Error('Invalid context');
    }
}
